exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2G5HAVy8O61srDXMoLvKv9{margin-bottom:20px}html[dir] ._3DsRdX9WC9p0k9WhgBTiZL{padding-bottom:10px}", ""]);

// exports
exports.locals = {
	"txpEventsPanel": "_2G5HAVy8O61srDXMoLvKv9",
	"txpPrivateOption": "_3DsRdX9WC9p0k9WhgBTiZL"
};